import React, { useEffect, useState } from 'react'
import Text from '../controllers/Text'
import styled from 'styled-components'
import SelectPerspectives from '../main/options/model/edit/SelectPerspectives'
import { Toggle } from '../main/options/model/Toggle'
import { Database } from '../main/options/model/types'
import { checkIsValid, checkCollection } from './helper/GeneralInformation'

function GeneralInformation({
    database,
    setDatabase,
    editEventType = false,
    isValid,
    setIsValid
}: {
    database: Database
    setDatabase: (database: Database) => void
    editEventType?: boolean
    isValid: boolean
    setIsValid: (boolean) => void
}) {
    const [error, setError] = useState<string>('')

    useEffect(() => {
        if (!!error && error.length > 0) {
            if (isValid) setIsValid(false)
        } else {
            const currIsValid = checkIsValid(database)
            if (currIsValid !== isValid) {
                setIsValid(currIsValid)
            }
        }
    }, [database])
    return (
        <>
            <Text
                label="Name"
                isRequire={true}
                onChange={name => setDatabase({ ...database, databaseName: name })}
                value={database?.databaseName}
            />
            <Text
                label="Collection Name"
                isRequire={true}
                disabled={!editEventType}
                onChange={name => setDatabase({ ...database, eventType: name })}
                value={database?.eventType}
                infoText=""
                onChangeMessageError={text => {
                    const msgError = checkCollection(text, editEventType)
                    if (!!msgError) setError(msgError)
                    else if (error.length > 0) setError('')
                    return msgError
                }}
            />
            <div style={{ width: '100%', padding: '8px 24px' }}>
                <SelectPerspectives
                    onChange={perspective => setDatabase({ ...database, perspective: perspective })}
                    select={database.perspective}
                />
            </div>
            <div style={{ width: '100%', padding: '8px 24px', display: 'flex', justifyContent: 'flex-start' }}>
                <label>Date reference</label>
                <Toggle
                    key="dateref"
                    label={!database.dateReference ? 'Disabled' : 'Enable'}
                    disabled={false}
                    onChange={status => {
                        setDatabase({ ...database, dateReference: status })
                    }}
                    status={database.dateReference}
                />
            </div>
            <div style={{ width: '100%', padding: '8px 24px', display: 'flex', justifyContent: 'flex-start' }}>
                <label>Use skip realtime</label>
                <Toggle
                    key="dateref"
                    label={!database.skipRealtime ? 'Disabled' : 'Enable'}
                    disabled={false}
                    onChange={status => {
                        setDatabase({ ...database, skipRealtime: status })
                    }}
                    status={database.skipRealtime}
                />
            </div>
        </>
    )
}


export { GeneralInformation }
